import { WidgetBaseOption, WidgetQuery } from './widget.options';
import { WidgetChartType } from './widget.chart.type';

export function isWidgetChartType(value: string): value is WidgetChartType {
    return [
        WidgetChartType.Pie,
        WidgetChartType.Doughnut,
        WidgetChartType.Bar,
        WidgetChartType.Column,
        WidgetChartType.Line,
        WidgetChartType.Polar,
        WidgetChartType.Area,
        WidgetChartType.Radar,
        WidgetChartType.StackBar,
        WidgetChartType.StackColumn
    ].some(v => v === value);
}


export interface WidgetChartOption extends WidgetBaseOption {
    type: WidgetChartType | null,

    query: WidgetQuery,
    visualization: WidgetChartVisualization,
}


export interface WidgetChartVisualization {
    colors?: any[];
    legend?: any;
}

// DATA 

export interface WidgetChartDataset {
    /** Labels for data with the corresponding dataset index */
    labels: string[],
    datasets: WidgetChartData[]
}
export interface WidgetChartData {
    /** Label for dataset */
    label?: string
    data: any[],
    backgroundColor?: string | string[],
}